export default __webpack_public_path__ + "static/media/sad-face.f1c7409b.svg";